import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import BodyText from 'LuxKit/Typography/BodyText'
import HeightFillingImage from 'components/Common/HeightFillingImage'
import TextLink from '../../../../../../../LuxKit/TextLink'
import ClickableLink from 'components/Common/Clickable/ClickableLink'

const OfferLink = styled(ClickableLink)`
  position: relative;
  display: block;
`

const Root = styled(Pane)`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1.5fr;
  grid-template-rows: ${rem(120)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  background: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, ${rem(150)}) minmax(0, ${rem(96)});
  }
`

const Content = styled(PaneBody)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: ${rem(120)};
  padding: ${rem(12)};
  max-width: ${rem(360)};

  > * + * {
    margin-top: ${rem(12)};
  }

  ${mediaQueryUp.tablet} {
    text-align: left;
    padding: ${rem(20)};
  }
`

interface Props extends App.HubTile {}

function DreamBlockItem(props: Props) {
  const intl = useIntl()
  const {
    title,
    image,
    tileLink,
    hrefLink,
    linkText,
  } = props

  const toLink = tileLink ? `/${tileLink}` : undefined

  return (
    <OfferLink to={toLink} href={hrefLink}>
      <Root>
        <HeightFillingImage
          id={image}
          alt={title}
        />
        <Content>
          <div>
            <BodyText lineClamp={2} variant="large" weight="bold">
              {title}
            </BodyText>
          </div>
          <TextLink size="medium" to={toLink} href={hrefLink}>
            {linkText ?? intl.formatMessage({ id: 'hprSZP-3AHEWXU6zspro', defaultMessage: 'Read more', description: 'Default link text for a dream block item when no custom text is provided' })}
          </TextLink>
        </Content>
      </Root>
    </OfferLink>
  )
}

export default DreamBlockItem
